<template>
  <div class="top_box">
    <div class="banner">
      <img class="banner-img" :src="introduce.navigationImgUrl" alt="" />
      <div class="shadowClass"></div>
      <div class="title">{{ bannerMessage.title }}</div>
      <div class="line"></div>
      <div class="content">{{ bannerMessage.subtitle }}</div>
      <div class="menu_list">
        <div
          class="menu_item"
          v-for="(item, index) in menuList"
          :key="'menu' + index"
          @click="changeItem(item)"
          :class="{ isChoose: chooseKey.key === item.key }"
        >
          <div class="menu_title">{{ item.name }}</div>
          <div
            class="pic_box"
            :style="{ opacity: chooseKey.key === item.key ? 1 : 0 }"
          >
            <img class="down_icon" src="@/assets/text/down.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 数字栏 -->
    <div class="infoList" id="numberBox" ref="numberBox">
      <div
        class="infoBox"
        :style="{
          'grid-template-columns': `repeat(${infoList.length}, 1fr)`,
        }"
      >
        <div class="infoItem" v-for="(ele, index) of infoList" :key="index">
          <div class="wordBox">
            <div class="ItemBox">
              <div class="num">
                {{
                  ele.number.indexOf("+") > 0
                    ? ele.number.split("+")[0]
                    : ele.number
                }}
                <div v-if="ele.number.indexOf('+') > 0" class="strBox">+</div>
                <div
                  class="danwei"
                  :style="{
                    'margin-left': ele.number.indexOf('+') > 0 ? '0px' : '8px',
                  }"
                >
                  {{ ele.unit }}
                </div>
              </div>
              <div class="name">{{ ele.title }}</div>
            </div>
            <!-- <div>
                <p>
                  <span>{{ ele.number }}</span
                  >{{ ele.unit }}
                </p>
                <span>{{ ele.title }}</span>
              </div> -->
          </div>
          <div class="lineBox" v-if="index !== infoList.length - 1">
            <div class="line"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_box" v-if="!ifShowDetail">
      <div class="first_card">
        <figure class="box">
          <!-- <div class="artcile_title">板块介绍</div> -->
          <figcaption
            class="article"
            v-html="normalizeRichText(introduce.content)"
          ></figcaption>
        </figure>
      </div>

      <div class="productBox">
        <div class="title">部分产品展示</div>
        <div class="contain">
          <div class="carousel">
            <div class="slide" ref="slide">
              <div
                class="item"
                v-for="(item, index) in configList"
                :key="index + 'item'"
              >
                <div class="shadow">{{ item.title }}</div>
                <img :src="item.thumbUrl" alt="" />
              </div>
            </div>
          </div>
          <div class="btnBox">
            <img
              src="@/assets/text/leftBtnNew.png"
              alt=""
              class="btn"
              @click="transFn('left')"
            />
            <img
              src="@/assets/text/rightBtnNew.png"
              alt=""
              class="btn"
              @click="transFn('right')"
            />
          </div>
        </div>
      </div>
      <div class="titleTop" v-if="companies.length > 0">相关成员单位</div>
      <div class="else_card" v-if="companies.length > 0">
        <div
          class="else_item"
          v-for="(item, index) in companies"
          :key="'itemC' + index"
          @click="turnDetail(item)"
        >
          <div class="img_box">
            <img :src="item.thumbUrl" alt="" />
          </div>
          <div class="bottom_item">
            <div class="title" :title="item.title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="main_box2" v-else>
      <div class="small_title">
        <span @click="turnBack">板块业务</span> / {{ chooseKey.name }}
      </div>
      <div class="article_box">
        <div class="title">{{ chooseCom.title }}</div>
        <img :src="chooseCom.thumbUrl" alt="" />
        <div class="article" v-html="normalizeRichText(chooseCom.content)"></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, onMounted, nextTick } from "vue";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();
let ifShowDetail = ref(false);
let bannerMessage = ref({});
let introduce = ref({});
let chooseCom = ref({});
let companies = ref([]);
let itemLeft = ref(0);
let configList = ref([]);
const slide = ref(null);
const infoList = ref([]);
const options = {
  root: null, // 相对于浏览器视窗
  rootMargin: "0px",
  threshold: 0.1, // 至少10%的元素可见时触发
};
let chooseKey = ref({
  name: "新能源板块",
  key: 126,
  key2: 127,
  key3: 142,
  key4: 143,
});
let menuList = ref([
  {
    name: "新能源板块",
    key: 126,
    key2: 127,
    key3: 142,
    key4: 143,
  },
  {
    name: "航空航天复材制造板块",
    key: 129,
    key2: 130,
    key3: 140,
    key4: 141,
  },
  {
    name: "海洋船舶及相关制造",
    key: 159,
    key2: 162,
    key3: 160,
    key4: 161,
  },
  {
    name: "其他装备制造板块",
    key: 169,
    key2: 172,
    key3: 170,
    key4: 171,
  },
  {
    name: "工美文化",
    key: 164,
    key2: 167,
    key3: 165,
    key4: 166,
  },
  {
    name: "军工板块",
    key: 135,
    key2: 136,
    key3: 146,
    key4: 147,
  },
  {
    name: "民爆板块",
    key: 132,
    key2: 133,
    key3: 144,
    key4: 145,
  },
  {
    name: "产业服务板块",
    key: 174,
    key2: 177,
    key3: 175,
    key4: 176,
  },
]);
const changeItem = (item) => {
  // chooseKey.value = key;
  router.push({
    query: {
      id: item.key,
    },
  });
  // getInit();
};
const transFn = (data) => {
  let width = slide.value.offsetWidth;
  let moveLength = width / 4;
  if (data === "right") {
    if (itemLeft.value > -moveLength * (configList.value.length - 4)) {
      itemLeft.value -= moveLength;
    } else {
      itemLeft.value = 0;
    }
  } else if (data === "left") {
    if (itemLeft.value < 0) {
      itemLeft.value += moveLength;
    }
  }
  let transV = `translateX(${itemLeft.value}px)`;
  slide.value.style.transform = transV;
};
const animateNumber = (target, index) => {
  let current = 0;
  const increment = (target - current) / (2000 / 12);
  const interval = setInterval(() => {
    current += increment;
    if (current >= target) {
      current = target;
      clearInterval(interval);
    }
    infoList.value[index].number = Math.ceil(current);
  });
};
const doSomething = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (infoList.value.length > 0) {
        nextTick(() => {
          infoList.value[0] && animateNumber(infoList.value[0].number, 0);
          infoList.value[1] && animateNumber(infoList.value[1].number, 1);
          infoList.value[2] && animateNumber(infoList.value[2].number, 2);
          infoList.value[3] && animateNumber(infoList.value[3].number, 3);
        });
      }
    }
  });
};
const turnDetail = (data) => {
  // ifShowDetail.value = true;
  chooseCom.value = data;
  // window.scrollTo({
  //   top: 660,
  //   behavior: "smooth",
  // });
  window.open(data.link, "_blank");
};
const turnBack = () => {
  ifShowDetail.value = false;
};
const getBanner = async () => {
  let res = await api.getPageConfigDetail(90);
  if (res.code === "0") {
    bannerMessage.value = res.res.data;
  }
};
getBanner();

const getInit = async () => {
  let api1 = api.getPageConfigDetail(chooseKey.value.key);
  let api2 = api.getZtzlList({ resourceId: chooseKey.value.key2 });
  let api3 = api.getNumberListInfo({ resourceId: chooseKey.value.key3 });
  let api4 = api.getPageConfigList(chooseKey.value.key4);
  let [res1, res2, res3, res4] = await Promise.all([api1, api2, api3, api4]);
  if (res1.code === "0") {
    introduce.value = res1.res.data;
  }
  if (res2.code === "0") {
    companies.value = res2.res.data;
  }
  if (res3.code === "0") {
    let arr = res3.res.data.slice(0, 4) || [];
    arr.forEach((ele) => {
      ele.number = ele.number;
    });
    infoList.value = arr;
  }
  if (res4.code === "0") {
    configList.value = res4.res.data;
    // if (configList.value.length < 4 && configList.value.length !== 0) {
    //   configList.value.push({
    //     thumbUrl: require(`@/assets/text/noPic.png`),
    //   });
    // }
  }
};
// getInit();
watch(
  () => route,
  (newval) => {
    console.log(newval, "newval------");
    if (newval && newval.query.id) {
      chooseKey.value = menuList.value.filter(
        (item) => item.key === newval.query.id * 1
      )[0];
      getInit();
      ifShowDetail.value = false;
      nextTick(() => {
        window.scrollTo({
          top: 660,
          behavior: "smooth",
        });
      });
    }
  },
  { deep: true, immediate: true }
);
onMounted(() => {
  // const observer = new IntersectionObserver(doSomething, options);
  // const numberBox = document.getElementById("numberBox");
  // observer.observe(numberBox);
});
</script>
<style lang="less" scoped>
:deep(p) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 36px;
  font-style: normal;
}

.titleTop {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 67px;
  text-align: center;
  font-style: normal;
  margin-bottom: 30px;
  margin-top: 80px;
}

.productBox {
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    line-height: 67px;
    text-align: center;
    font-style: normal;
    margin-bottom: 30px;
  }

  .contain {
    position: relative;
    width: 100%;

    .carousel {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 258px;
      z-index: 2;

      .slide {
        display: flex;
        position: relative;
        transition: transform 0.3s ease;

        .item {
          position: relative;
          flex-shrink: 0;
          width: calc(25% - 20px);
          height: 258px;
          margin: 0 10px;
          overflow: hidden;

          .shadow {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 22px;
            text-align: justify;
            font-style: normal;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
          }

          img {
            width: 100%;
            height: 100% // height: auto;
          }
        }

        .item:hover {
          .shadow {
            opacity: 1;
          }
        }
      }
    }

    .btnBox {
      position: absolute;
      left: -74px;
      top: 50%;
      transform: translate(0, -50%);
      width: calc(100% + 148px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 1;

      img {
        cursor: pointer;
        width: 44px;
        height: 44px;
      }
    }
  }
}

.infoList {
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  height: 200px;
  background: #006AB1;
  padding: 0 128px;

  // margin-top:30px;
  // margin-bottom: 80px;
  .infoBox {
    margin: 0 auto;
    width: calc(100% - 16.66vw);
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    display: grid;
    // grid-template-columns: repeat(4, 1fr);
    box-sizing: border-box;

    .infoItem {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 200px;

      .lineBox {
        position: relative;
        width: 1px;
        height: 200px;
        background-color: rgba(255, 255, 255, 0.32);
        display: flex;
        align-items: center;
        justify-content: center;

        .line {
          position: absolute;
          width: 3px;
          height: 20px;
          background: #FFFFFF;
        }
      }

      .wordBox {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .ItemBox {
          .num {
            display: flex;
            justify-content: center;
            font-family: DINAlternate, DINAlternate;
            font-weight: bold;
            font-size: 60px;
            color: #FFFFFF;
            line-height: 82px;

            .strBox {
              display: inline-block;
              height: 80px;
              font-size: 40px;
              line-height: 94px;
              font-weight: 400;
              margin-left: 4px;
            }

            .danwei {
              font-size: 23px;
              display: inline-block;
              height: 80px;
              font-weight: 400;
              line-height: 100px;
            }
          }

          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 28px;
            text-align: center;
          }
        }
      }
    }
  }
}

.main_box2 {
  width: 100%;
  padding: 87px 8.33vw 160px 8.33vw;
  box-sizing: border-box;

  .small_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    text-align: left;
    font-style: normal;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      font-style: normal;
      cursor: pointer;
    }
  }

  .article_box {
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #333333;
      line-height: 67px;
      font-style: normal;
      text-align: center;
      margin: 35px 0px 42px 0px;
    }

    img {
      width: 100%;
      height: 564px;
    }

    .article {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      margin-top: 36px;
      padding-bottom: 36px;
    }

    .detail_list {
      div {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        text-align: left;
        font-style: normal;
      }
    }
  }
}

.top_box {
  width: 100%;

  .banner {
    width: 100%;
    height: 660px;
    position: relative;

    .shadowClass {
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(33, 48, 63, 0) 0%, rgba(27, 55, 68, 0.5) 100%);
    }

    .title {
      position: absolute;
      left: 170px;
      top: 263px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
    }

    .line {
      position: absolute;
      left: 170px;
      top: 366px;
      width: 60px;
      height: 2px;
      background: rgba(255, 255, 255, 0.4);
    }

    .content {
      position: absolute;
      left: 170px;
      top: 397px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
    }

    .banner-img {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }

    .menu_list {
      width: 100%;
      height: 144px;
      position: absolute;
      bottom: -60px;
      display: flex;
      align-items: center;
      padding: 0px 128px;
      box-sizing: border-box;
      // justify-content: space-evenly;
      justify-content: space-between;

      .isChoose {
        background: #006ab1 !important;
      }

      .menu_item {
        width: 10vw;
        padding-top: 14px;
        box-sizing: border-box;
        cursor: pointer;
        background: transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .menu_title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.95vw;
          color: #ffffff;
          line-height: 28px;
          white-space: nowrap;
        }

        .pic_box {
          z-index: 1;
          width: 100%;
          display: flex;
          padding-top: 22px;
          align-items: center;
          justify-content: center;

          .down_icon {
            width: 12px;
            height: 12px;
            z-index: 1;
          }
        }
      }
    }
  }

  .main_box {
    position: relative;
    width: 100%;
    padding: 30px 8.33vw 160px 8.33vw;
    box-sizing: border-box;

    .first_card {
      margin-bottom: 60px;
      margin-top: 30px;

      .box {
        .img1 {
          float: right;
          width: 48.125vw;
          height: 48.15vh;
          margin: 1.02vh 0px 1.02vh 4.9vw;
          border-radius: 8px;
        }

        .artcile_title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 40px;
          color: #333333;
          line-height: 56px;
          text-align: center;
          font-style: normal;
          margin-bottom: 28px;
        }

        .article {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          // font-size: 1.25vw;
          // line-height: 4.8vh;
          font-size: 16px;
          line-height: 38px;
          text-align: justify;
          font-style: normal;
        }
      }
    }

    .first_card::after {
      content: "";
      display: block;
      clear: both;
    }

    .else_card {
      // display: grid;
      // grid-template-columns: repeat(3, 1fr);
      // grid-gap: 3.65vw 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      .else_item {
        // width: 366px;
        flex-shrink: 0;
        cursor: pointer;
        height: 66px;
        margin-bottom: 23px;
        background: #ffffff;
        box-shadow: 0px 0px 7px 0px rgba(111, 128, 141, 0.25);
        border-radius: 18px;
        transition: transform 0.3s ease;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        padding: 0px 30px 0px 10px;
        margin-right: 20px;
        box-sizing: border-box;

        .img_box {
          width: 54px;
          height: 54px;
          background: #d8d8d8;
          overflow: hidden;
          margin-right: 20px;

          img {
            width: 100%;
            height: 100%;
            transition: transform 0.3s ease;
          }
        }

        .bottom_item {
          // width: calc(100% - 94px);
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 12;
          box-sizing: border-box;

          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            text-align: left;
            font-style: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }

          @media screen and (max-height: 767px) {
            .article {
              -webkit-line-clamp: 3;
            }
          }

          @media screen and (min-height: 768px) and (max-height: 1080px) {
            .article {
              -webkit-line-clamp: 5;
            }
          }

          .bottom_btn {
            cursor: pointer;
            position: absolute;
            bottom: 26px;
            left: 34px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 20px;
            color: #006ab1;
            line-height: 28px;
            font-style: normal;
          }
        }
      }

      .else_item:last-child {
        margin-right: 0px !important;
      }

      .else_item:hover {
        // .img_box {
        //   img {
        //     transform: scale(1.1);
        //   }
        // }
      }
    }
  }
}
</style>
